module.exports = __webpack_public_path__ + "img/friends-logo4.b35eaf29.png";